import {PlayerExperienceLevel} from "../types";

export const translateExperienceValue = (experience: PlayerExperienceLevel | undefined) => {
    if (!experience) {
        return {
            color: 'grey',
            value: 'N/A'
        }
    }
    const colors = {
        [PlayerExperienceLevel.NEWBIE]: 'green',
        [PlayerExperienceLevel.BEGINNER]: 'cyan',
        [PlayerExperienceLevel.ADEPT]: 'orange',
        [PlayerExperienceLevel.MASTER]: 'purple',
    };
    return {value: experience, color: colors[experience]};
}